import styled, { css, keyframes } from 'styled-components';
import { useController } from './controller';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


export const spinAnimation = keyframes`
    to{
        transform: rotate(360deg);
    }
`;

export const popUpAnimation = keyframes`
    from{
        transform: rotateY(90deg);
        opacity: 0;
    }
    to{
        transform: rotateY(0deg);
        opacity: 1;
    }
`;

export const main = styled.div`
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    position: fixed;
    background-color: var(--palette-one-blue);
    display: flex;
    flex-direction: row;
    z-index: 999999999999;
    justify-content: center;
    align-items: center;
    opacity: 0;
    animation: ${popUpAnimation} 0.25s ease-in-out forwards;

    @media (max-width: 900px) {
        flex-direction: column;
        justify-content: center;
        gap: 40px;
    }
`;
export const curiositiesArea = styled.div`
    width: 100%;
    justify-content: center;
    align-items: center;
    align-content: center;
    border-radius: 20px;
    position: relative;
`;
export const loadingContainer = styled.div`
    width: 100%;
    display: flex;
    gap: 20px;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    @media (max-width: 900px) {
        border-top: 1px solid var(--palette-one-white);
        width: 80%;
        padding: 40px 0;
        gap: 20px;
        flex-direction: row;
    }
`;
export const loadingContainerIcons = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;
export const loadingContainerIconsArea = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;
export const loadingContainerIcon = styled(FontAwesomeIcon) <{ direction: string, index: number }>`
    font-size: 3rem;
    color: var(--palette-one-white);
    animation: ${spinAnimation} 2s linear infinite ${props => props.direction == 'right' ? 'normal' : 'reverse'};
    ${props => props.index == 0 ? `
        transform: rotate(0deg);
    ` : ''};
    ${props => props.index == 1 ? `
        margin-right: -1.5px;
        transform: rotate(5deg);
    ` : ''};
    ${props => props.index == 2 ? `
        margin-left: -1.5px;
        transform: rotate(10deg);
    ` : ''};
`;
const boxShadowPulse = keyframes`
    0% {
        box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);
    }
    70% {
        box-shadow: 0 0 0 25px rgba(255, 255, 255, 0);
    }
    100% {
        box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
    }
`;
export const containerIconNoAnim = styled(FontAwesomeIcon)`
    font-size: 3rem;
    color: var(--palette-one-white);
    border-radius: 50%;
    animation: ${boxShadowPulse} 1s infinite;
    cursor: pointer;
`;
export const loadingContainerText = styled.h1<{continueActive: boolean}>`
    color: var(--palette-one-white);
    font-size: 1.75rem;
    text-align: center;
    text-transform: capitalize;
    margin: 0;
    padding: 10px;

    ${props => props.continueActive ? css`
        text-decoration: underline;
        cursor: pointer;
    ` : ''};
`;
export const curiositiesTitle = styled.h1`
    color: var(--palette-one-white);
    font-size: 1.75rem;
    text-transform: capitalize;
    margin: 0 0 20px 0;
    text-align: center;

    @media(max-width: 500px){
        font-size: 1.4rem;
    }
`;
export const curiosities = styled.ul`
    width: 75%;
    max-height: 100%;
    color: var(--palette-one-white);
    padding: 0px 25px 0px 100px;
    align-self: center;
    justify-self: center;
    font-size: 1.5rem;
    text-align: center;
    overflow-y: auto;
    white-space: pre-line;
    align-content: center;
    justify-content: center;

    @media(max-width: 1200px){
        font-size: 1.3rem;
    }

    @media(max-width: 900px){
        font-size: 1.1rem;
        padding: 0px 25px 0px 25px;
    }
`;
export const curiosity = styled.li`
    color: var(--palette-one-white);
    width: 100%;
    font-size: 1.25rem;
    text-align: left;
    margin: 15px 0;
    overflow-wrap: anywhere;
    white-space: pre-wrap;

    @media(max-width: 500px){
        font-size: 1rem;
        margin: 10px 0;
    }
`;